import { InMemoryCache } from '@apollo/client';

import introspection from '~/graphql/generated/introspection';
import typePolicies from '~/graphql/type-policy';

export default new InMemoryCache({
  possibleTypes: introspection.possibleTypes,
  typePolicies,
});
